import { Mail, MapPin, Clock, Building, Globe } from "lucide-react";

export default function ContactPage() {
  const contactInfo = [
    {
      icon: Mail,
      label: "Email",
      value: "info@bastionguardhealthcare.in",
      href: "mailto:info@bastionguardhealthcare.in",
    },
    {
      icon: Building,
      label: "Company",
      value: "BastionGuard Medical Technologies Pvt. Ltd.",
      href: null,
    },
    {
      icon: Clock,
      label: "Business Hours",
      value: "Monday - Friday: 9:00 AM - 6:00 PM IST",
      href: null,
    },
  ];

  return (
    <div className="noise-bg min-h-screen pt-20" data-testid="contact-page">
      {/* Hero Section */}
      <section className="section-padding relative overflow-hidden" data-testid="contact-hero-section">
        {/* Background effects */}
        <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-[120px]"></div>
        
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <span className="caption mb-4 block" data-testid="contact-label">Contact Us</span>
            <h1 className="heading-1 text-white mb-6" data-testid="contact-title">
              Let's <span className="gradient-text">Connect</span>
            </h1>
            <p className="body-large" data-testid="contact-description">
              Have questions about our medical devices or healthcare solutions? 
              We'd love to hear from you. Reach out to our team for inquiries, 
              partnerships, or just to say hello.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="pb-24 md:pb-32" data-testid="contact-content-section">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-2xl font-semibold text-white mb-8" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="contact-info-title">
                Get in Touch
              </h2>
              <div className="space-y-6">
                {contactInfo.map((item, index) => (
                  <div
                    key={item.label}
                    className="flex gap-4 group"
                    data-testid={`contact-info-${index}`}
                  >
                    <div className="icon-glow flex-shrink-0 group-hover:glow-cyan transition-all duration-300">
                      <item.icon className="w-5 h-5" />
                    </div>
                    <div>
                      <p className="font-medium text-white mb-1">{item.label}</p>
                      {item.href ? (
                        <a
                          href={item.href}
                          className="text-slate-400 hover:text-cyan-400 transition-colors"
                        >
                          {item.value}
                        </a>
                      ) : (
                        <p className="text-slate-400">{item.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Additional Info */}
              <div className="mt-12 card-glass" data-testid="contact-additional-info">
                <h3 className="font-semibold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>For Partnerships</h3>
                <p className="text-sm text-slate-400 mb-4">
                  If you're a healthcare institution, investor, or potential partner 
                  interested in collaboration, please reach out via email with your 
                  proposal.
                </p>
                <p className="text-sm text-slate-500">
                  We review all partnership inquiries and respond within 2-3 business days.
                </p>
              </div>
            </div>

            {/* Location Visual */}
            <div className="flex items-center justify-center">
              <div className="relative w-full max-w-md">
                {/* Globe visualization */}
                <div className="aspect-square glass-card rounded-3xl flex items-center justify-center relative overflow-hidden">
                  {/* Grid pattern */}
                  <div className="absolute inset-0 opacity-20" style={{
                    backgroundImage: `radial-gradient(circle, rgba(6, 182, 212, 0.3) 1px, transparent 1px)`,
                    backgroundSize: '20px 20px'
                  }}></div>
                  
                  {/* Glowing ring */}
                  <div className="absolute inset-8 rounded-full border border-cyan-500/30 animate-glow-pulse"></div>
                  <div className="absolute inset-16 rounded-full border border-cyan-500/20"></div>
                  <div className="absolute inset-24 rounded-full border border-cyan-500/10"></div>
                  
                  <div className="text-center relative z-10">
                    <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center">
                      <Globe className="w-10 h-10 text-cyan-400" />
                    </div>
                    <p className="text-xl font-semibold text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Based in India</p>
                    <p className="text-cyan-400 text-sm">Serving Global Healthcare</p>
                  </div>
                </div>
                
                {/* Decorative elements */}
                <div className="absolute -top-4 -right-4 w-24 h-24 border border-cyan-500/20 rounded-2xl"></div>
                <div className="absolute -bottom-4 -left-4 w-32 h-32 border border-cyan-500/10 rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
